<template>
  <div>
    <div v-if="carregando == true" class="carregando">
      <img width="130px" :src="iconeCarregando" />
      <br />
      <br />Carregando...
    </div>
    <div :class="`${insideLogin || insideBox ? '' : 'container'}`">
      <form ref="form" role="form" @submit.stop.prevent="onSubmit">
        <div v-if="!insideLogin" class=" mb-2">
          <h3 class="mt-3 tituloPagina">Esqueci Minha Senha</h3>
        </div>
        <div id="inputs " class="form-transparent ">
          <div class="row">
            <div class="col-sm-12 col-lg-12 mt-2">
              <fg-input
                size="large"
                class="w-full"
                name="CPF"
                id="CPF"
                label="CPF"
                v-model="form.cpf"
                v-validate="{ required: true }"
                :state="validateState('CPF')"
                :class="validateClass('CPF')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                v-mask="'###.###.###-##'"
                :disabled="isUpdate"
              />
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-sm-12 col-lg-12">
              <n-button
                nativeType="submit"
                class="btn-block   btn-primario-formulario "
                type="success"
                >Recuperar Senha</n-button
              >

              <center>
                <a
                  v-if="insideLogin"
                  class="text-center"
                  style="text-decoration:underline"
                  @click="emitRetorno()"
                  href="javascript:void(0)"
                  >Voltar
                </a>
                <router-link
                  v-else
                  class=""
                  style="text-decoration:underline"
                  :to="'/Login'"
                  >Voltar Para o Login</router-link
                >
              </center>

              <errosAlert
                :exibeErro="exibeErro"
                :msgErro="msgErro"
                :listaErro="$validator.errors.all()"
              ></errosAlert>
            </div>
          </div>

          <!--div class="row" v-if="isUpdate==true">
            <div class="col-sm-12 col-lg-12 mt-2  text-right">
              <div v-if="!dados.dataDesativada" class="alert alert-warning">
                <center>Caso deseje desativar sua conta VetMark clique no botão abaixo. Você poderá reativar sua conta a qualquer momento efetuando login e clicando em REATIVAR.</center>
                <br />
                <n-button
                  v-if="!dados.dataDesativada"
                  @click="desativar()"
                  nativeType="button"
                  round
                  type="danger"
                >Desativar</n-button>
              </div>

              <n-button v-else @click="reativar()" nativeType="button" round type="success">Reativar</n-button>
            </div>
          </div-->
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import {
  Button,
  Checkbox,
  Radio,
  FormGroupInput,
  Slider,
  Switch,
  Alert,
  Modal,
} from '@/components';

import { Popover, Tooltip, DatePicker } from 'element-ui';

import Password from 'vue-password-strength-meter';
import storage from './../../services/storage';
import service from './../../services';
import cpfCnpj from './../../services/cpfCnpj';

import errosAlert from './errosAlert';
import swal from 'sweetalert';

import locale from './../../locale';
export default {
  components: {
    Password,
    errosAlert,
    Alert,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Radio.name]: Radio,
    [FormGroupInput.name]: FormGroupInput,
    [Switch.name]: Switch,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Popover.name]: Popover,
    Slider,
    Modal,
  },
  props: ['dados', 'insideBox', 'insideLogin'],
  data() {
    return {
      iconeCarregando: service.getEnvIconeCarregando(),
      score: 0,
      codPerfilAux: null,
      showModal: false,
      showModal2: false,
      carregando: false,
      especialidades: [],
      exibeErro: false,
      msgErro: '',
      isUpdate: false,
      redirect: this.$route.query.redirect,
      form: {
        cpf: null,
      },
      radios: {
        radioOn: '2',
        radioOff: '2',
      },
      checkboxes: [],
      switches: {
        defaultOn: true,
        defaultOff: false,
      },
      sliders: {
        simple: 30,
        rangeSlider: [20, 60],
      },
    };
  },
  methods: {
    desativar() {
      this.showModal = true;
    },
    reativar() {
      this.showModal2 = true;
    },
    showFeedback({ suggestions, warning }) {
      console.log('🙏', suggestions);
      console.log('⚠', warning);
    },
    showScore(score) {
      this.score = score;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (this.veeFields[ref]) {
        if (this.veeFields[ref].dirty) {
          if (this.veeFields[ref].valid == false) {
            return 'has-danger';
          } else {
            return 'has-success';
          }
        }
      }
      return null;
    },
    resetForm() {
      return new Promise((resolve, reject) => {
        this.form = {
          email: null,
          senha: null,
        };
        this.$nextTick(() => this.$validator.reset());
        resolve();
      });
    },

    onSubmit(event) {
      console.log(this.form);
      this.$validator.validateAll().then(result => {
        if (result) {
          this.carregando = true;

          this.form.codPerfil = this.codPerfil;

          service
            .post('Login', 'RecuperarSenha', this.form)
            .then(res => {
              this.carregando = false;
              this.exibeErro = false;
              swal(
                '=)',
                'Foi Enviada uma mensagem para Recuperação da sua senha',
                'success',
              );
            })
            .catch(error => {
              console.log(error);
              this.exibeErro = true;
              this.msgErro = 'Não foi possível Recuperar Senha, ' + error;
              this.carregando = false;
              swal('ops!', this.msgErro, 'error');
            });
        }
      });
    },
    emitRetorno() {
      this.$emit('returnLogin');
    },
  },
  mounted() {
    this.$validator.localize('ptBr', locale);
  },
};
</script>
<style scoped>
select {
  padding: 10px !important;
}
input[type='radio'],
input[type='checkbox'] {
  margin-right: 10px !important;
}
.btnbuscar {
  font-size: 24px;
  text-transform: uppercase;
  color: #094049;
}
.Teste {
  background-color: #ffffff;
  border: 1px solid #e3e3e3;
  border-radius: 30px !important;
  color: #2c2c2c !important;
  line-height: normal;
  font-size: 0.8571em !important;
  height: 100%;
}
</style>
<style>
.cardCadastro .form-check .form-check-sign::after {
  color: #fff;
}
</style>
